import { authHeader } from '../javascript/auth-header';
import { aggUniversityAlternateName_LowerCase, aggUniversityAlternateName, aggUniversityLongName, inWords, toTitleCase,numberWithCommas, percentageFormat, billionNumberFormat, toCurrency, thousandNumberFormat, getStateAbbr } from '../components/Common/Helpers';
import { isAgg } from '../components/Common/Helpers';
import {
    FactSheetState
} from "../interface/FactSheetInterface";


export function resetEmploymentBullets() {

    return (dispatch) => {
        //dispatch({
        //    type: "RESET_EMPLOYMENT_BULLETS",
        //    payload: ""
        //})
        dispatch({
            type: "DATA_PAGE1",
            payload: {}
        });
        dispatch({
            type: "SET_TEXT",
            payload: {
                "employment_text": "",
                "employment_bullets": "",
                "top_heading": "",
                "stayed_bullet": "",
                "spending_heading": "",
                "statelegislative_heading1": "",
                "statelegislative_heading2": ""
            }
        });
        dispatch({
            type: "FACT_SHEET_HOMESTATE_INFO",
            payload: {}
        });


    }
}

export function downloadReport(FactSheetState: FactSheetState, factSheetType) {
    return dispatch => {

        if (factSheetType == "stateLegislative") {
            dispatch(downloadFile(table(FactSheetState.legislativeUpperTable, FactSheetState.current_year, FactSheetState.start_year), "legislativetable1.csv"))
            dispatch(downloadFile(table(FactSheetState.legislativeLowerTable, FactSheetState.current_year, FactSheetState.start_year), "legislativetable2.csv"))
        }
        else {
            dispatch(downloadFile(congressTable(FactSheetState.spending_congress, FactSheetState.current_year, FactSheetState.start_year), "congressTable.csv"))
        }
    }
}

function congressTable(spending_congress, current_year, start_year) {
    var text = "district no.,representative," + current_year + "," + start_year + "-" + current_year;
    var reduced = spending_congress;
    reduced.forEach((item, index) => {
        const rep_name = (item.rep_name == '') ? 'Vacant' : item.rep_name;

        text += "\n";
        text += "\"" + item.district_name + "\""
        text += ","

        text += "\"" + rep_name + "\""
        text += ","

        text += "\"" + (item.payment_amt || 0) + "\""
        text += ","

        text += "\"" + (item.payment_amt_range || 0) + "\""
    });
    return text;
}


export function downloadFile(text, filename) {
    var element = document.createElement('a');

    element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    document.body.removeChild(element);
    return {
        type: "DOWNLOAD",
        payload: "download"
    }
}



function table(legislativeTable, current_year, start_year) {
    var text = "district no.,representative," + current_year + "," + start_year + "-" + current_year;
    var reduced = legislativeTable;
    reduced.forEach((item, index) => {
        const rep_name = (decodeURI(item.rep) == '') ? 'Vacant' : decodeURI(item.rep);


        text += "\n";
        text += "\"" + item.district + "\""
        text += ","

        text += "\"" + rep_name + "\""
        text += ","

        text += "\"" + (item.latest || 0) + "\""
        text += ","

        text += "\"" + (item.range || 0) + "\""
    });
    return text;
}

export function loadFactSheet(display_id, reportVintage, sbEmployeeVintage, isLegislative) {
    return dispatch => {
        //let url = `/IRISReportsMicroservice/api/FactSheet/factsheet-homestate-info/${display_id}/${sbEmployeeVintage}`
        let url = `/IRISReportsMicroservice/api/FactSheet/factsheet-homestate-info/${display_id}/${reportVintage}`
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(jsonHomeState => {

                dispatch({
                    type: "FACT_SHEET_HOMESTATE_INFO",
                    payload: jsonHomeState
                });

                url = `/IRISReportsMicroservice/api/FactSheet/${display_id}/${reportVintage}/${sbEmployeeVintage}/${isLegislative}`
                headers = authHeader();
                fetch(url, { method: 'GET', headers: headers })
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (json) {

                        dispatch({
                            type: "DATA_PAGE1",
                            payload: json
                        });

                        var employment_text = "";
                        var top_heading = "";
                        
                        
                        if (json["total_employees"] != 0 && display_id != "999040" && display_id != "14105" && display_id != "64556") {
                            
                            employment_text = `In ${json["current_year"]}, ${aggUniversityLongName(json["university"])} employed ${numberWithCommas(json["total_employees"])} people on federally funded research grants.`;

                            var employment_bullets = `<ul><li>${numberWithCommas(json["total_faculty"])}, or ${percentageFormat(json["percent_faculty"], 1)} were faculty members</li><li>${numberWithCommas(json["total_students"])}, or ${percentageFormat(json["percent_students"], 1)} were students`
                            if (json["total_students"] == 0) {
                                employment_bullets = `<ul><li>${numberWithCommas(json["total_faculty"])}, or ${percentageFormat(json["percent_faculty"], 1)} were faculty members</li>`
                            }
                            top_heading = `Top 5 Federal Research Funding Agencies, by Employment<br/>${aggUniversityAlternateName(json["university"])}, FY ${json["current_year"]}`
                        }
                        else {
                            employment_text = `In ${json["current_year"]}, ${json["university"].replace("Texas CPUPC IRIS members", "these five universities collectively")} spent a total of $${numberWithCommas(thousandNumberFormat(json["spendingStateCountry_country_payment"]))} on goods and services from ${numberWithCommas(json["uniqueAwardCount_country_unique_award_count"])} sponsored research projects (federal and non-federal).`;
                            employment_bullets = `<ul></ul>`;
                            top_heading = `Top 5 Research Funding Agencies by In-State Spending on Research-Related Goods and Services`;
                        }

                        var stayed_bullet = `<ul className="verticalspace">`;
                        if (jsonHomeState["pct_staying_in_homestate"] != 0 && display_id != "14105" && !isAgg(display_id) && display_id != "84698") {
                            stayed_bullet += `<li>${jsonHomeState["pct_staying_in_homestate"]}% of employees on sponsored research projects at ${aggUniversityAlternateName_LowerCase(jsonHomeState["university"])} between ${jsonHomeState["start_year"]} and ${jsonHomeState["end_year"]} found work in the state of ${jsonHomeState["homestate"]} after leaving the university, earning an average of $${thousandNumberFormat(jsonHomeState["homestate_salary"])} per year.</li>`
                        }
                        else {
                            if (json["covidCFDASpendingHomeState_country_payment"] != null)
                                stayed_bullet += `<li>${json["university"].replace("Texas CPUPC IRIS members", "The five CPUPC/IRIS universities")} ${(display_id == "999040") ? "in this report" : ""} spent $${numberWithCommas(thousandNumberFormat(json["covidCFDASpendingHomeState_country_payment"]))} on goods and services in ${json["statename"]} for COVID-related research since 2020.</li>`
                        }


                        if (json["industries"] !== undefined && json["industries"].length > 0 && display_id != "14105" && !isAgg(display_id) && display_id != "84698") {
                            stayed_bullet += `<li>The top ${(json["statename"])} industries for employees formerly working on sponsored research projects are`;

                            json["industries"].forEach((i, index) => {
                                if (index == json["industries"].length - 1) {
                                    stayed_bullet += " and";
                                    stayed_bullet += ` ${toTitleCase(i["industry"])}, with an average yearly salary of $${(thousandNumberFormat(i["average_salary"]))}.`;
                                }
                                else
                                    stayed_bullet += ` ${toTitleCase(i["industry"])}, with an average yearly salary of $${(thousandNumberFormat(i["average_salary"]))};`;

                            })
                            stayed_bullet += "</li>";
                        }
                        else {
                            const years = inWords(+(json["current_year"]) - +(json["start_year"]) + 1);
                            if (json["upperSpendingCount"] == null || json["upperSpendingCount"] == 0) {
                                stayed_bullet += `<li>In the past ${years} years, ${json["university"].replace("Texas CPUPC IRIS members", "the five CPUPC/IRIS universities")} purchased research-related goods and services from vendors in ${json["congressSpendingCount"]} of ${json["congressTotalCount"]} congressional districts.</li>`;
                            }
                            else {
                                stayed_bullet += `<li>In the past ${years} years, ${json["university"].replace("Texas CPUPC IRIS members", "the five CPUPC/IRIS universities")} purchased research-related goods and services from vendors in ${json["upperSpendingCount"]} of ${json["upperTotalCount"]} state senate districts, and ${json["lowerSpendingCount"]} of ${json["lowerTotalCount"]} state house districts.</li>`;
                            }
                        }
                        stayed_bullet += `</ul>`;

                        var spending_heading = `${aggUniversityAlternateName(json["university"])} Research-Related Spending (Federal), by Congressional District (${getStateAbbr(json["statename"])})`;
                        var statelegislative_heading1 = `${aggUniversityAlternateName(json["university"])}<br/>Research-Related Spending (Federal and Non-Federal),<br/>by State Senate District (${getStateAbbr(json["statename"])})`;
                        var statelegislative_heading2 = `${aggUniversityAlternateName(json["university"])}<br/>Research-Related Spending (Federal and Non-Federal),<br/>by State House/Assembly District (${getStateAbbr(json["statename"])})`;
                        dispatch({
                            type: "SET_TEXT",
                            payload: {
                                "employment_text": employment_text,
                                "employment_bullets": employment_bullets,
                                "top_heading": top_heading,
                                "stayed_bullet": stayed_bullet,
                                "spending_heading": spending_heading,
                                "statelegislative_heading1": statelegislative_heading1,
                                "statelegislative_heading2": statelegislative_heading2
                            }
                        });

                    })

            })
            .catch(error => {
                console.log("homestate info error", error);
            })


        
    };
}

